(() => {
  const loginPagePath = '/pages/accedi';

  const safeStorefrontPath = (value) => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
      return '/';
    }

    try {
      const candidate = new URL(value, window.location.origin);
      if (candidate.origin !== window.location.origin) return '/';
      if (candidate.pathname === loginPagePath || candidate.pathname.startsWith('/customer_authentication/')) return '/';
      return `${candidate.pathname}${candidate.search}${candidate.hash}` || '/';
    } catch (_error) {
      return '/';
    }
  };

  document.querySelectorAll('[data-sd-login-link]').forEach((link) => {
    const currentPath = safeStorefrontPath(`${window.location.pathname}${window.location.search}${window.location.hash}`);
    link.href = `${loginPagePath}?return_to=${encodeURIComponent(currentPath)}`;
  });

  const authenticationLink = document.querySelector('[data-sd-authentication-link]');
  if (authenticationLink) {
    const requestedPath = new URLSearchParams(window.location.search).get('return_to');
    const returnTo = safeStorefrontPath(requestedPath);
    const authenticationUrl = authenticationLink.dataset.sdAuthenticationUrl;
    if (authenticationUrl) {
      const target = new URL(authenticationUrl);
      target.searchParams.set('return_to', returnTo);
      authenticationLink.href = target.toString();
    }
  }
})();
